import { z } from 'zod';
import type {
  RematchInboundReceiptOfficialSettlementRequest,
  RematchInboundReceiptOfficialSettlementResponse,
} from './rematch-inbound-receipt-official-settlement.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';

export const RematchInboundReceiptOfficialSettlementRequestSchema: z.ZodType<RematchInboundReceiptOfficialSettlementRequest> =
  z
    .object({
      companyId: z.uuid(),
      snapshotId: z.uuid(),
      receiptId: z.uuid(),
    })
    .strict();

export const RematchInboundReceiptOfficialSettlementResponseSchema: z.ZodType<RematchInboundReceiptOfficialSettlementResponse> =
  z
    .object({
      receipt: InboundReceiptDetailDtoSchema,
      snapshotId: z.uuid(),
    })
    .strict();
